// FILE: src/components/FlowBuilder/properties/DelayProperties.jsx
import React from 'react';
import {
  VStack,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  HStack,
} from '@chakra-ui/react';

export default function DelayProperties({ nodeConfig, setNodeConfig, updateNodeData }) {
  return (
    <VStack spacing={4} align="stretch">
      <FormControl>
        <FormLabel fontSize="sm">Step Name</FormLabel>
        <Input
          size="sm"
          value={nodeConfig.label}
          onChange={(e) => setNodeConfig({ ...nodeConfig, label: e.target.value })}
          placeholder="e.g., Wait 1 Day"
        />
      </FormControl>

      <FormControl>
        <FormLabel fontSize="sm">Duration</FormLabel>
        <HStack>
          <Input
            size="sm"
            type="number"
            min="1"
            value={nodeConfig.duration}
            onChange={(e) => setNodeConfig({ ...nodeConfig, duration: e.target.value })}
            placeholder="1"
          />
          <Select
            size="sm"
            value={nodeConfig.unit}
            onChange={(e) => setNodeConfig({ ...nodeConfig, unit: e.target.value })}
          >
            <option value="minutes">Minutes</option>
            <option value="hours">Hours</option>
            <option value="days">Days</option>
            <option value="weeks">Weeks</option>
          </Select>
        </HStack>
      </FormControl>

      <Button size="sm" colorScheme="purple" onClick={updateNodeData}>
        Update Node
      </Button>
    </VStack>
  );
}